import { notebookModule } from './module'
import type { NotebookItemJSON } from './types'

const getItemsGroupedByType = () => {
    const items = notebookModule.state.notebookItems
    return items.reduce((acc, i) => {
        const type = i.metadata.type
        const itemsByType = acc.get(type) || []
        itemsByType.push(i)
        acc.set(type, itemsByType)

        return acc
    }, new Map<NotebookItemJSON['metadata']['type'], NotebookItemJSON[]>())
}

export default {
    getItemsGroupedByType,
}
